import { render, staticRenderFns } from "./TenantsView.vue?vue&type=template&id=2e0cc337"
import script from "./TenantsView.vue?vue&type=script&lang=js"
export * from "./TenantsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports